import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电视剧", to: "/category/tv" },
  { label: "电影", to: "/category/movie" },
  { label: "演员", to: "/actors" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <header className="sticky top-0 z-40 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg">
              <i className="ri-movie-2-line"></i>
            </span>
            <span className="font-heading font-extrabold text-lg md:text-xl text-foreground-950 whitespace-nowrap">
              我的老婆姐姐
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-6">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form
            onSubmit={handleSearch}
            className="hidden md:flex items-center gap-2 bg-background-100 border border-background-200 rounded-full px-3 py-1.5 w-56 lg:w-64"
          >
            <i className="ri-search-line text-foreground-400 text-base"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视剧、演员"
              className="bg-transparent outline-none text-sm w-full text-foreground-900 placeholder:text-foreground-400"
            />
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-2-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4 space-y-1">
          <form
            onSubmit={handleSearch}
            className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-full px-3 py-2 mb-3"
          >
            <i className="ri-search-line text-foreground-400 text-base"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视剧、演员"
              className="bg-transparent outline-none text-sm w-full text-foreground-900 placeholder:text-foreground-400"
            />
          </form>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `block px-3 py-2.5 rounded-md text-sm font-medium ${
                  isActive
                    ? "text-primary-600 bg-primary-50"
                    : "text-foreground-700 hover:bg-background-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      )}
    </header>
  );
}